export const INVOICE_BUCKETS = ['Current', '1-30', '31-60', '61-90', '90+'] as const;
export type InvoiceBucket = (typeof INVOICE_BUCKETS)[number];
export type InvoiceDirection = 'ar' | 'ap';
export interface FinanceInvoiceQuery {
  projectId?: string;
  search?: string;
  bucket?: InvoiceBucket;
  page?: number;
  pageSize?: number;
  asOf?: string;
}
export interface FinanceInvoiceRecord {
  id: string;
  invoiceNumber: string;
  partyName: string;
  project: { id: string; projectNumber: string; name: string } | null;
  invoiceDate: string;
  dueDate: string | null;
  amount: string;
  balanceDue: string;
  recordedStatus: string;
  recordedAgingBucket: string;
  bucket: InvoiceBucket | null;
  daysPastDue: number | null;
  sourceSystem: string | null;
  sourceReference: string | null;
  sourceDocumentNumber: string | null;
  updatedAt: string;
}
export interface FinanceInvoicePage {
  direction: InvoiceDirection;
  asOfDate: string;
  assembledAt: string;
  currency: null;
  sourceCompleteness: 'not_verified';
  scope: { projectId: string | null; search: string | null; bucket: InvoiceBucket | null };
  summary: { balance: string; count: number; overdueBalance: string; overdueCount: number };
  aging: Array<{ bucket: InvoiceBucket; balance: string; count: number }>;
  items: FinanceInvoiceRecord[];
  meta: { page: number; pageSize: number; total: number; totalPages: number };
}

/** Preserve recorded decimal precision without asserting a currency absent from the source. */
export function formatRecordedAmount(value: string | null | undefined): string {
  if (!value || !/^-?\d+(?:\.\d{1,2})?$/.test(value)) return '—';
  const [whole, fraction = ''] = value.split('.');
  return `${whole!.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${fraction.padEnd(2, '0')}`;
}
